import { components } from "react-select";
import {
  EmployeeAdvanceStatus,
  employeeAdvanceStatusMap,
} from "features/EmployeeAdvances/constants/employee-advance.constants";
import type { EmployeeAdvanceSelectOption } from "features/EmployeeAdvances/types/employee-advance.types";
import { formatCurrency } from "utils/currency";

function StatusBadge({ status }: { status: string | undefined }) {
  if (!status) return null;
  const entry = employeeAdvanceStatusMap[status as EmployeeAdvanceStatus];
  if (!entry) return null;
  return (
    <span className={`badge bg-${entry.color}-subtle text-${entry.color} ms-1`}>
      {entry.label}
    </span>
  );
}

export function EmployeeAdvanceOption(props: any) {
  const data = props.data as EmployeeAdvanceSelectOption;
  const remaining =
    data.remainingAmount != null && Number.isFinite(data.remainingAmount)
      ? data.remainingAmount
      : null;
  const total =
    data.amount != null && Number.isFinite(data.amount) ? data.amount : null;

  return (
    <components.Option {...props}>
      <div className="d-flex flex-column py-1">
        <div className="d-flex align-items-center justify-content-between gap-2">
          <span className="fw-medium text-body">{data.label}</span>
          <StatusBadge status={data.status} />
        </div>
        {remaining !== null || total !== null ? (
          <div className="d-flex justify-content-between mt-1">
            {remaining !== null ? (
              <small className="text-muted">
                Remaining:{" "}
                <span className="text-body">{formatCurrency(remaining)}</span>
              </small>
            ) : (
              <span />
            )}
            {total !== null ? (
              <small className="text-muted">
                Total:{" "}
                <span className="text-body">{formatCurrency(total)}</span>
              </small>
            ) : null}
          </div>
        ) : null}
      </div>
    </components.Option>
  );
}

export function EmployeeAdvanceSingleValue(props: any) {
  const data = props.data as EmployeeAdvanceSelectOption;
  const remaining =
    data.remainingAmount != null && Number.isFinite(data.remainingAmount)
      ? data.remainingAmount
      : null;

  return (
    <components.SingleValue {...props}>
      <span className="d-inline-flex align-items-center gap-1 min-w-0 text-truncate">
        <span className="text-truncate">{data.label}</span>
        {remaining !== null ? (
          <span className="text-muted text-truncate small">
            · Remaining {formatCurrency(remaining)}
          </span>
        ) : null}
      </span>
    </components.SingleValue>
  );
}
